/** @jsx h */
import { h } from 'preact'

import t from '../../../utils/translate'

const ClaimsSection = props => {
  const { claims } = props

  const claimsList = claims.map(claim => (
    <li
      class='ModalCard-listItem--capsule ClaimCapsule ClaimCapsule--small'
      key={claim.name}
    >
      <span class='ClaimCapsule-title ClaimCapsule-title--small'>
        {claim.name}
      </span>
    </li>
  ))

  return (
    <section class='ModalCard-section'>
      <h3 class='ModalCard-heading'>{t('proof_points.js.claims.label')}</h3>
      <ul class='ModalCard-list ModalCard-list--capsule'>{claimsList}</ul>
    </section>
  )
}

export default ClaimsSection
